import React from 'react'
import styled from 'styled-components'
import colors from '../../styles/colors'
import CheckIcon from 'images/checkV2.svg'
import { Field } from 'formik'

const CheckBox = styled.label`
  min-width: 100px;
  padding-left: 40px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
  position: relative;
  margin-right: 36px;
  cursor: pointer;
  z-index: 0;
  margin-bottom: 10px;
  user-select: none;

  ${({ fullWidth }) =>
    fullWidth ? 'display: block;' : 'display: inline-block;'}

  &:hover {
    opacity: 0.9;
  }

  & input {
    width: 0;
    height: 0;
    position: absolute;
    left: -1px;
    top: -1px;

    &:checked + span + svg {
      display: block !important;
    }
    &:checked + span:after {
      background-color: ${colors.greenMain};
    }
  }

  & span {
    &:after {
      box-sizing: border-box;
      position: absolute;
      content: '';
      left: 0;
      top: 0;
      width: 24px;
      height: 24px;
      border-radius: 4px;
      border: 1px solid #e8ecf3;
      background-color: ${colors.white};
    }
  }
`

const IconStyled = styled(CheckIcon)`
  display: none;
  position: absolute;
  left: 12px;
  top: 12px;
  transform: translate(-50%, -50%);
  fill: var(--black-carbon);
  width: 22px;
  height: 22px;
`

const FormCheckbox = ({ key, fullWidth, name, value, label, isSelected }) => (
  <CheckBox key={key} fullWidth={fullWidth}>
    <Field type="checkbox" name={name} value={value} checked={isSelected} />
    <span>{label}</span>
    <IconStyled />
  </CheckBox>
)

export default FormCheckbox
